/* MK 01.10.2026 : textes traduits fournis par window.MK_I18N.c (layout/theme.liquid) ; anglais par défaut */
function mkT(k, d) { try { return (window.MK_I18N && window.MK_I18N.c && window.MK_I18N.c[k]) || d; } catch (e) { return d; } }
/* Maison Kargani — PDP "Model wearing X" tag + bottom sheet.
   Mirrors the IG Shop Grid tag/sheet mechanism, sourced from each product
   image's alt text (set directly in Shopify admin, per-image). */
(function () {
  var SHEET_ID = 'mk-pdp-tag-sheet';

  function ensureSheet() {
    var existing = document.getElementById(SHEET_ID);
    if (existing) return existing;

    var backdrop = document.createElement('div');
    backdrop.className = 'mk-pdp-tag-backdrop';
    backdrop.id = SHEET_ID + '-backdrop';

    var sheet = document.createElement('div');
    sheet.className = 'mk-pdp-tag-sheet';
    sheet.id = SHEET_ID;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML =
      '<div class="mk-pdp-tag-sheet__handle"></div>' +
      '<button type="button" class="mk-pdp-tag-sheet__close" aria-label="Close">&times;</button>' +
      '<div class="mk-pdp-tag-sheet__title">' + mkT('s_3f2881d54aa3', "Model Info") + '</div>' +
      '<div class="mk-pdp-tag-sheet__text"></div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    function close() {
      sheet.classList.remove('is-open');
      backdrop.classList.remove('is-open');
    }
    backdrop.addEventListener('click', close);
    sheet.querySelector('.mk-pdp-tag-sheet__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    sheet.__mkClose = close;
    return sheet;
  }

  function openSheet(text) {
    var sheet = ensureSheet();
    var backdrop = document.getElementById(SHEET_ID + '-backdrop');
    sheet.querySelector('.mk-pdp-tag-sheet__text').textContent = text;
    // force reflow so the transition runs even if already in DOM
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    backdrop.classList.add('is-open');
  }

  function addTagToMedia(mediaEl, altText) {
    if (!mediaEl || mediaEl.dataset.mkTagDone) return;
    mediaEl.dataset.mkTagDone = '1';

    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'mk-pdp-tag-dot';
    dot.setAttribute('aria-label', mkT('s_e1e434d3543f', "Model info"));
    dot.innerHTML = '<span>i</span>';
    dot.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openSheet(altText);
    });
    mediaEl.appendChild(dot);
  }

  function scan(root) {
    root = root || document;
    var mediaEls = root.querySelectorAll ? root.querySelectorAll('.product__media') : [];
    mediaEls.forEach ? mediaEls.forEach(process) : Array.prototype.forEach.call(mediaEls, process);

    function process(mediaEl) {
      if (mediaEl.dataset.mkTagDone) return;
      var img = mediaEl.querySelector('img');
      if (!img) return;
      var alt = (img.getAttribute('alt') || '').trim();
      if (!alt) return;
      // Only real model info (alt starting with "Model" or "Mannequin") shows the i button.
      // Other alt texts are SEO descriptions and stay invisible.
      if (!/^(model|mannequin)\b/i.test(alt)) return;
      addTagToMedia(mediaEl, alt);
    }
  }

  function init() {
    scan(document);
    // Catch galleries that finish initializing (Swiper clones, variant image
    // swaps) slightly after first paint.
    setTimeout(function () { scan(document); }, 400);

    var galleries = document.querySelectorAll('.product__media-list, .product__media-list-wrapper');
    if (window.MutationObserver && galleries.length) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes && m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      });
      galleries.forEach ? galleries.forEach(function (g) { observer.observe(g, { childList: true, subtree: true }); })
        : Array.prototype.forEach.call(galleries, function (g) { observer.observe(g, { childList: true, subtree: true }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();